<template>
    <div class="cursor-pointer ml-4" @click="copyExample">
        <vs-icon :color="color" v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"></vs-icon>
    </div>
</template>

<script>
import {copy} from '@/utils/utils'

export default {
    props: {
        text: {
            type: String|Object|Array
        },
        color: {
            type: String,
            default: 'primary'
        }
    },

    methods: {
        _notification(title, text, success) {
            let settings = {
                title: title,
                text: text,
                color: 'success',
            }

            if (!success) {
                settings.color = 'danger'
                settings = {
                  ...settings,
                  ...this.$iconData('icon-alert-circle', 'fi-rr-exclamation')
                }
            }

            this.$vs.notify(settings)
        },

        copyExample() {
            try {
                copy(this.text)
                this._notification('Copied', 'Example copied', true)
            } catch (e) {
                this._notification('Error', 'Something went wrong!', false)
            }
        }
    }
}
</script>
